<h3 mat-dialog-title>Model Display Settings</h3>

<form class="form-container" (ngSubmit)="submitForm()">
  <mat-dialog-content>
    <mat-slide-toggle
      class="slider"
      [(ngModel)]="data.auto"
      name="auto"
      >
      Auto
    </mat-slide-toggle>
    @if (!data.isDepth) {
      <mat-slide-toggle
        [disabled]="!data.auto"
        class="slider"
        [(ngModel)]="data.autoSynced"
        name="autoSynced"
        style="margin-left: 10px;"
        >
        Sync IL/XL Ranges
      </mat-slide-toggle>
    }
    @if (data.isScaling) {
      <mat-slide-toggle
        class="slider"
        [(ngModel)]="data.global"
        name="global"
        >
        Global Scaling
      </mat-slide-toggle>
    }

    @if (data.slice_processing) {
      @if (
        !data.slice_processing.includes('_zero_centred_params_process')) {
        @if (!data.singleValue) {
          <div style="position: relative">
            <nz-input-group
              class="nz-input-group-floating-label"
              [nzSize]="'large'"
              [style.width.%]="100"
              >
              <label>Minimum Value</label>
              <nz-input-number
                style="width: 100%"
                [nzPrecision]="10"
                [disabled]="data.auto"
                placeholder="Minimum Value"
                name="min"
                [(ngModel)]="data.min"
                #minField
                />
            </nz-input-group>
            @if (this.data.auto) {
              <div
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            "
                (click)="clickInput(minField)"
              ></div>
            }
          </div>
        }
        @if (!data.singleValue) {
          <div style="position: relative">
            <nz-input-group
              class="nz-input-group-floating-label"
              [nzSize]="'large'"
              [style.width.%]="100"
              >
              <label>Maximum Value</label>
              <nz-input-number
                style="width: 100%"
                [nzPrecision]="10"
                [disabled]="data.auto"
                placeholder="Maximum Value"
                [(ngModel)]="data.max"
                name="max"
                #maxField
                />
            </nz-input-group>
            @if (this.data.auto) {
              <div
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            "
                (click)="clickInput(maxField)"
              ></div>
            }
          </div>
        }
        @if (data.singleValue) {
          <div style="position: relative">
            <nz-input-group
              class="nz-input-group-floating-label"
              [nzSize]="'large'"
              [style.width.%]="100"
              >
              <label>Clip Value</label>
              <input
                nz-input
                [disabled]="data.auto"
                placeholder="Clip Value"
                required
                type="number"
                noScrollNumber
                [(ngModel)]="data.offset"
                name="clipValue"
                #clip
                />
            </nz-input-group>
            @if (this.data.auto) {
              <div
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            "
                (click)="clickInput(clip)"
              ></div>
            }
          </div>
        }
      } @else {
        @if (!data.singleValue) {
          <div style="position: relative">
            <nz-input-group
              class="nz-input-group-floating-label"
              [nzSize]="'large'"
              [style.width.%]="100"
              >
              <label>Zero centred value</label>
              <input
                nz-input
                [disabled]="data.auto"
                placeholder="Zero centred value"
                required
                type="number"
                noScrollNumber
                [(ngModel)]="center_offset_value"
                name="center_offset_value"
                #offset
                />
            </nz-input-group>
            @if (this.data.auto) {
              <div
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            "
                (click)="clickInput(offset)"
              ></div>
            }
          </div>
        }
        @if (data.singleValue) {
          <div style="position: relative">
            <nz-input-group
              class="nz-input-group-floating-label"
              [nzSize]="'large'"
              [style.width.%]="100"
              >
              <label>Clip Value</label>
              <input
                nz-input
                [disabled]="data.auto"
                placeholder="Clip Value"
                required
                type="number"
                noScrollNumber
                [(ngModel)]="data.offset"
                name="clipValue"
                #clip
                />
            </nz-input-group>
            @if (this.data.auto) {
              <div
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            "
                (click)="clickInput(clip)"
              ></div>
            }
          </div>
        }
      }
    }

    @if (hasError && !data.singleValue) {
      <div class="error-text">
        Please ensure you enter value minimum and maximum values
      </div>
    }
    @if (hasError && data.singleValue) {
      <div class="error-text">
        Please ensure you enter a valid clip value
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions class="button-container">
    <button mat-raised-button color="primary" type="submit">Update</button>
    <button mat-raised-button mat-dialog-close color="basic" type="reset">
      Cancel
    </button>
  </mat-dialog-actions>
</form>
